import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/classCountSagas";
import MonthPicker from "../../../../components/reactMonthPicker/reactMonthPicker";

const DatePicker = () => {
  const {
    selectedRequestDates: { startDate, endDate },
    currentUser: { calendarStartDate, maxDate }
  } = useSelector((state) => {
    let { selectedRequestDates, currentUser } = state.classCount;
    return { selectedRequestDates, currentUser };
  }, shallowEqual);

  const dispatch = useDispatch();

  return (
    <>
      <MonthPicker
        startDate={startDate}
        endDate={endDate}
        calendarStartDate={calendarStartDate}
        calendarEndDate={maxDate}
        updateDates={(startDate, endDate) =>
          dispatch(actionCreators.updateDates({ startDate, endDate }))
        }
      />
    </>
  );
};

export default DatePicker;
